exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contain {\n  position: absolute;\n  z-index: 3;\n  color: white;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n  .contain h3 {\n    font-size: 3em;\n    text-transform: uppercase;\n    font-weight: 300;\n    letter-spacing: 10px; }\n  .contain ul {\n    padding: 15px;\n    font-size: 0.875em; }\n\n.filter {\n  position: absolute;\n  z-index: 2;\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%; }\n\n@media screen and (max-width: 768px) {\n  .contain {\n    top: 50%;\n    left: 0;\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n    padding-left: 10px; }\n    .contain h3 {\n      font-size: 1.5em;\n      font-weight: bold;\n      letter-spacing: 0; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/home/slider/slider.component.scss
// module id = ../../../../../src/components/home/slider/slider.component.scss
// module chunks = main